import ApiConnector from "../connector";

class UsersActions {
  get = async () => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.get("/users/");
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.detail;
    }

    return result;
  };
}

export default new UsersActions();
